

































import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { IProject, IUser } from '@/lib/interfaces';
import { getAllProjects, getFavoriteProjects, toogleFavoriteProject } from '@/services/api.service';
import { mapState } from 'vuex';

@Component({
  computed: mapState(['users']),
})
export default class Projects extends Vue {
  /** users from vuex */
  public users!: { string: IUser };

  private projects: IProject[] = [];
  private favorites: { string?: boolean } = {};
  private get sortedProjects() {
    return this.projects.slice().sort((a, b) => {
      if (this.favorites[a._id!] === this.favorites[b._id!]) {
        return a.title.localeCompare(b.title);
      }
      if (this.favorites[a._id!]) {
        return -1;
      }
      return 1;
    });
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    const [projects, favorites] = await Promise.all([getAllProjects(), getFavoriteProjects()]);
    next((vm: Projects) => {
      vm.projects = projects;
      favorites.forEach((fav) => {
        vm.favorites[fav] = true;
      });
    });
  }

  private async onClickFav(project: IProject, isFavorite: boolean) {
    await toogleFavoriteProject(project._id!, { checked: !isFavorite });
    if (isFavorite) {
      Vue.delete(this.favorites, project._id!);
    } else {
      Vue.set(this.favorites, project._id!, !isFavorite);
    }
  }
}
